import React from "react";

export const NotificationsIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="notifications-icon"
    >
      <path
        d="M18.5 8C18.5 6.4087 17.8679 4.88258 16.7426 3.75736C15.6174 2.63214 14.0913 2 12.5 2C10.9087 2 9.38258 2.63214 8.25736 3.75736C7.13214 4.88258 6.5 6.4087 6.5 8C6.5 15 3.5 17 3.5 17H21.5C21.5 17 18.5 15 18.5 8Z"
        stroke="#848484"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2295 21C14.0537 21.3031 13.8014 21.5547 13.4978 21.7295C13.1941 21.9044 12.8499 21.9965 12.4995 21.9965C12.1492 21.9965 11.8049 21.9044 11.5013 21.7295C11.1977 21.5547 10.9453 21.3031 10.7695 21"
        stroke="#848484"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
